import { useCallback, useEffect, useMemo } from "react";
import { useGetRemindersQuery } from "@store/reminderApi";
import {
  NotificationEvents,
  NotificationService,
} from "@service/notification.service";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useGetCompanionsQuery } from '@store/companionApi';

const notificationService = NotificationService.instance;

export const useReminders = () => {
  const selectedPatientId = useSelector(
    (state: RootState) => state.home.selectedPatientId,
  );
  const userId = useSelector((state: RootState) => state.auth.user?.id);
  const { data: reminders, refetch } = useGetRemindersQuery(
    { patientId: selectedPatientId! },
    { skip: !selectedPatientId, refetchOnFocus: true },
  );
  const { data: companions } = useGetCompanionsQuery(
    { patientId: selectedPatientId!, userId: userId! },
    {
      skip: !selectedPatientId,
    },
  );
  const defaultCompanion = useMemo(() => {
    return companions?.data.find(({ isDefault }) => isDefault);
  }, [companions]);

  const onNotificationWorkerMessage = useCallback(
    (e: MessageEvent) => {
      if (e.data.type === NotificationEvents.POLL_NOTIFICATIONS) {
        refetch();
      }
    },
    [refetch],
  );

  useEffect(() => {
    if (!reminders?.data) {
      return;
    }
    notificationService.scheduleNotifications(reminders.data, defaultCompanion);
  }, [reminders, defaultCompanion]);

  useEffect(() => {
    const _handler = onNotificationWorkerMessage;
    notificationService.subscribeToMessages(_handler);

    return () => {
      notificationService.unsubscribeFromMessages(_handler);
    };
  }, [onNotificationWorkerMessage]);
};
